import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { AuthState } from 'src/app/core/states/auth.state';

import { UntilDestroy } from '@ngneat/until-destroy';
import { User } from 'src/app/core/models/user.model';

export interface BreadcrumbItem {
    label: string;
    link?: string;
}

@Injectable({
    providedIn: 'root',
})
@UntilDestroy()
export class HeaderService {
    public loggedUser$: Observable<User | null> = inject(Store).select(AuthState.loggedUser);

    private breadcrumbsObs = new BehaviorSubject<BreadcrumbItem[]>([]);
    public breadcrumbs$: Observable<BreadcrumbItem[]> = this.breadcrumbsObs.asObservable();

    constructor() {}

    public setBreadcrumbs(breadcrumbs: BreadcrumbItem[]) {
        this.breadcrumbsObs.next(breadcrumbs);
    }
}
